import InputLegend from "./InputLegend";
export default InputLegend;